import { render } from "./Sale.vue?vue&type=template&id=7647ac2c"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"
script.render = render

export default script